import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { tokens } from "../../theme";

const formatSc = (value) =>
  Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Prize for every winning rank, for the numbers in the form. rows = [{ rank, prize }]. */
const PrizeTable = ({ rows }) => {
  if (!rows.length) {
    return null;
  }
  const total = rows.reduce((sum, row) => sum + row.prize, 0);

  return (
    <div style={{ marginTop: "16px" }}>
      <div style={{ fontWeight: 700, color: tokens.text }}>Prize per rank</div>
      <div style={{ fontSize: "12px", color: tokens.textDim, marginBottom: "6px" }}>
        Total {formatSc(total)} SC across {rows.length} winners.
      </div>

      <TableContainer component={Paper} style={{ maxHeight: 300 }}>
        <Table size="small" stickyHeader className="c_table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Rank</TableCell>
              <TableCell align="center">Prize (SC)</TableCell>
              <TableCell align="center">Share of Pool</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.rank}>
                <TableCell align="center">#{row.rank}</TableCell>
                <TableCell align="center">{formatSc(row.prize)}</TableCell>
                {/* A dynamic pool starts at 0, so every share is 0 too. */}
                <TableCell align="center">{total > 0 ? ((row.prize / total) * 100).toFixed(2) : "0.00"}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PrizeTable;
